import { redirect } from 'react-router';
import { loadOnboarding, onboardingComplete } from '../lib/onboarding/store';
import { currentSession, identityOf } from '../lib/supabase';
import type { OnboardingLoaderData } from '../lib/types';

/**
 * The induction sits outside the root layout: its loader would bounce people
 * straight back here, since being unfinished is exactly why they arrived.
 *
 * Anyone already through goes to the studio — the way back in to change an
 * answer is `/profile`, which keeps the navigation and drops the ceremony.
 */
export async function onboardingLoader(): Promise<OnboardingLoaderData | Response> {
  const session = await currentSession();
  if (!session) return redirect('/signed-out');

  const profile = await loadOnboarding(session);
  if (onboardingComplete(profile)) return redirect('/');

  return { identity: identityOf(session), profile };
}
